import AmbientEgg from "./AmbientEgg";

/**
 * Shai-Hulud, on the Transmissions page — or rather not him, which is the point.
 * You never see the worm, only the wave of sand it pushes ahead of itself.
 *
 * A signal moving under the surface of a list of signals is about as neat as the
 * pun gets, so this one earns its place more than most. Slow (54s) and wide: the
 * horror of the thing is the scale, and something small and quick would read as
 * a mouse.
 */
const SandRipple = () => (
  <AmbientEgg
    label="Shai-Hulud. You never see the worm, only the sand it moves."
    width={84}
    height={22}
    motion="pace"
    durationSeconds={54}
    /* Opens upward, into the gap under the Signal in Focus card. Downward would
       put it straight on the Transmissions heading directly beneath. */
    tip="top"
  >
    <span className="block">
      <style>{`
        /* The crest breathes slightly, so the mound reads as displaced sand
           rather than a fixed shape being slid across the page. */
        @keyframes ripple-swell {
          0%, 100% { transform: scaleY(1); }
          50%      { transform: scaleY(1.35); }
        }
        /* Grains thrown off the crest, drifting behind it. */
        @keyframes ripple-grain {
          0%       { opacity: 0; transform: translate(0, 0); }
          30%      { opacity: 0.7; }
          100%     { opacity: 0; transform: translate(-9px, -5px); }
        }
        .ripple-crest { animation: ripple-swell 4.5s ease-in-out infinite;
                        transform-origin: 50% 100%; }
        .ripple-g1    { animation: ripple-grain 3.2s linear infinite; }
        .ripple-g2    { animation: ripple-grain 3.2s linear infinite 1.1s; }
        .ripple-g3    { animation: ripple-grain 3.2s linear infinite 2.2s; }
      `}</style>

      <svg
        width="84"
        height="22"
        viewBox="0 0 84 22"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="text-cyan-400"
      >
        {/* the sand line */}
        <path d="M1 18 L20 18" />
        <path d="M64 18 L83 18" />
        {/* the mound being pushed along it — the only thing you ever see */}
        <path className="ripple-crest" d="M20 18 C28 18, 30 7, 42 7 C54 7, 56 18, 64 18" />
        {/* grains coming off the crest */}
        <g strokeWidth="1.4">
          <path className="ripple-g1" d="M44 7 L45 6" />
          <path className="ripple-g2" d="M40 8 L41 7" />
          <path className="ripple-g3" d="M47 9 L48 8" />
        </g>
      </svg>
    </span>
  </AmbientEgg>
);

export default SandRipple;
